// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactform {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 150px;
  background-color: var(--color-creme);
  color: var(--color-dark-blue);
  width: 100%;
  font-family: "SawtonCircular-Regular";
}

.labelInput {
  font-size: 16px;
  margin-top: 10px;
  text-indent: 15px;
}

.formField {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border: none;
  border-radius: 10px;
  background-color: rgb(216, 212, 212);
  color: var(--color-blue);
  font-size: 14px;
  box-sizing: border-box;
}

.formField::placeholder {
  color: var(--color-blue);
}

textarea.formField {
  resize: vertical;
  min-height: 100px;
}

.app__contactForm_Checkbox {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.formFieldCheckbox {
  margin-right: 10px;
}

.app__contactForm_Checkbox .labelInput {
  margin: 0;
}

.submit-button-reserve {
  padding: 10px 20px;
  background-color: var(--color-blue);
  color: var(--color-white);
  border: none;
  border-radius: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  font-family: "SawtonCircular-Bold";
  overflow: hidden;
  letter-spacing: 0.04em;
  margin: 30px 0;
}

.submit-button-reserve:hover {
  /* Dunklere Farbe im Hover-Zustand */
  box-shadow: 0px 0px 20px 8px rgba(0, 63, 100, 0.3); /* Sanfterer Leuchteffekt */
}

@media screen and (max-width: 1400px) {
  .contactform {
    padding: 0px 100px;
  }
}
@media screen and (max-width: 450px) {
  .contactform {
    padding: 0px 40px;
  }
}
@media screen and (max-width: 320px) {
  .contactform {
    padding: 0px 25px;
  }
}
/* Add more styles as needed for responsiveness and additional elements */
`, "",{"version":3,"sources":["webpack://./src/container/ContactForm/contactForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,4DAA4D;EAC5D,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kDAAkD,EAAE,2BAA2B;AACjF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA,yEAAyE","sourcesContent":[".contactform {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0px 150px;\r\n  background-color: var(--color-creme);\r\n  color: var(--color-dark-blue);\r\n  width: 100%;\r\n  font-family: \"SawtonCircular-Regular\";\r\n}\r\n\r\n.labelInput {\r\n  font-size: 16px;\r\n  margin-top: 10px;\r\n  text-indent: 15px;\r\n}\r\n\r\n.formField {\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin-top: 5px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background-color: rgb(216, 212, 212);\r\n  color: var(--color-blue);\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.formField::placeholder {\r\n  color: var(--color-blue);\r\n}\r\n\r\ntextarea.formField {\r\n  resize: vertical;\r\n  min-height: 100px;\r\n}\r\n\r\n.app__contactForm_Checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-top: 5px;\r\n}\r\n.formFieldCheckbox {\r\n  margin-right: 10px;\r\n}\r\n\r\n.app__contactForm_Checkbox .labelInput {\r\n  margin: 0;\r\n}\r\n\r\n.submit-button-reserve {\r\n  padding: 10px 20px;\r\n  background-color: var(--color-blue);\r\n  color: var(--color-white);\r\n  border: none;\r\n  border-radius: 10px;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n  font-family: \"SawtonCircular-Bold\";\r\n  overflow: hidden;\r\n  letter-spacing: 0.04em;\r\n  margin: 30px 0;\r\n}\r\n\r\n.submit-button-reserve:hover {\r\n  /* Dunklere Farbe im Hover-Zustand */\r\n  box-shadow: 0px 0px 20px 8px rgba(0, 63, 100, 0.3); /* Sanfterer Leuchteffekt */\r\n}\r\n\r\n@media screen and (max-width: 1400px) {\r\n  .contactform {\r\n    padding: 0px 100px;\r\n  }\r\n}\r\n@media screen and (max-width: 450px) {\r\n  .contactform {\r\n    padding: 0px 40px;\r\n  }\r\n}\r\n@media screen and (max-width: 320px) {\r\n  .contactform {\r\n    padding: 0px 25px;\r\n  }\r\n}\r\n/* Add more styles as needed for responsiveness and additional elements */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
